import { memo } from "react"

interface TdEnergyValueProps {
  value: number | string
}

export const EnergyPassportProductCell = memo(({ value }: TdEnergyValueProps) => {
  return <td className="bg-zinc-50 dark:bg-zinc-700">{value}</td>
})
